import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ToolbarSecondaryComponent } from './toolbar-secondary.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ToolbarSecondaryComponent],
  exports: [ToolbarSecondaryComponent],
})
export class ToolbarSecondaryModule {}
export { ToolbarSecondaryComponent } from './toolbar-secondary.component';
